import {
    CertificateIssuedToText,
    CertificateIssuedByText,
    CertificateValidFromToText,
    CertificateDetailsText,
} from './CertificateDetails.locstring.json';
import loc, { format } from 'owa-localize';
import Section from './Section';
import { observer } from 'mobx-react';

import * as React from 'react';

interface CertificateDetailsProps {
    certIssuedTo?: string;
    certIssuedBy?: string;
    certValidFrom?: string;
    certValidTo?: string;
}

const CertificateDetails = (props: CertificateDetailsProps) => {
    const detailsRowElements: JSX.Element[] = [];

    props.certIssuedTo &&
        detailsRowElements.push(
            <div key="certIssuedTo">{format(loc(CertificateIssuedToText), props.certIssuedTo)}</div>
        );
    props.certIssuedBy &&
        detailsRowElements.push(
            <div key="certIssuedBy">{format(loc(CertificateIssuedByText), props.certIssuedBy)}</div>
        );
    props.certValidTo &&
        props.certValidFrom &&
        detailsRowElements.push(
            <div key="certValidFromTo">
                {format(loc(CertificateValidFromToText), props.certValidFrom, props.certValidTo)}
            </div>
        );

    if (!detailsRowElements.length) {
        return null;
    }

    return <Section title={loc(CertificateDetailsText)}>{detailsRowElements}</Section>;
};

export default observer(CertificateDetails);
